import "./components/preloader";
import "./components/joomla";
import "./components/progress-to-top";
import "./components/reveal-effects";
import "./components/anim-menu-btn";
import "./components/flexi-header";
import "./components/tabs";
import "./components/modal-window";
import "./components/modal-video";
import StickyHeader from "./components/sticky-header";
import CategorieNav from "./components/categorie-nav";
import GdprClassObserver from "./components/gdpr-class-observer";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import Isotope from "isotope-layout";

const setLogoPadding = () => {
    const fHeaderGrid = document.querySelector(".f-header__nav-grid");
    const fHeaderLogoWrap = document.querySelector(".f-header__nav-logo-wrapper");
    const leftOffset = fHeaderGrid.offsetLeft;

    fHeaderLogoWrap.style.paddingRight = `${leftOffset}px`;
};

// init
(() => {

    // GDPR Class Observer
    new GdprClassObserver();

    // Sticky Header
    const stickyHeader = document.querySelector(".f-header--sticky");
    if (stickyHeader) {
        new StickyHeader(stickyHeader);
    }

    // Contacts Nav
    const contactsNav = document.querySelector(
        '[data-element="contact-tabs-nav"]',
    );

    if (contactsNav) {
        new CategorieNav(contactsNav, {
            scrollMarginTop: window.innerWidth > 1280 ? 120 : 0,
        });
    }

    // Header Slider
    const headerSlider = document.querySelector('[data-element="header-slider"]');
    if (headerSlider) {
        new Swiper(headerSlider, {
            slidesPerView: 1,
            autoHeight: false,
            modules: [Pagination],
            loop: false,
            grabCursor: true,

            navigation: {
                nextEl: ".swiper__button-next.header-slider",
                prevEl: ".swiper__button-prev.header-slider",
            },

            pagination: {
                el: ".swiper-slider-pagination",
                type: "bullets",
                clickable: true,
                renderBullet: function (index, className) {
                    return (
                        '<div class="' +
                        className +
                        ' border-primary-500 bg-transparent border-2 w-6 h-6 rounded-full flex items-center justify-center opacity-100"><span class="rounded-full bg-transparent w-3 h-3"></span></div>'
                    );
                },
            },
        });
    }

    // News Slider
    const newsSlider = document.querySelector('[data-element="newsslider"]');
    if (newsSlider) {
        new Swiper(newsSlider, {
            slidesPerView: 1,
            autoHeight: false,
            modules: [Navigation, Pagination],
            loop: false,
            spaceBetween: 15,

            navigation: {
                nextEl: ".swiper__button-next.mod-articlesnews-slider",
                prevEl: ".swiper__button-prev.mod-articlesnews-slider",
            },
            pagination: {
                el: ".swiper-news-pagination",
                type: "bullets",
                clickable: true,
                renderBullet: function (index, className) {
                    return (
                        '<div class="' +
                        className +
                        ' border-primary-500 bg-transparent border-2 w-6 h-6 rounded-full flex items-center justify-center opacity-100"><span class="rounded-full bg-transparent w-3 h-3"></span></div>'
                    );
                },
            },
        });
    }

    // Carousel
    const carousel = document.querySelector('[data-element="carousel"]');
    if (carousel) {
        new Swiper(carousel, {
            slidesPerView: 1.5,
            autoHeight: false,
            spaceBetween: 15,
            centeredSlides: true,
            modules: [Navigation, Pagination],
            loop: true,
            grabCursor: true,

            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 3.5,
                },
            },

            navigation: {
                nextEl: ".swiper__button-next.mod-carousel",
                prevEl: ".swiper__button-prev.mod-carousel",
            },

            pagination: {
                el: ".swiper-carousel-pagination",
                type: "bullets",
                clickable: true,
                renderBullet: function (index, className) {
                    return (
                        '<div class="' +
                        className +
                        ' border-white bg-transparent border-2 w-6 h-6 rounded-full flex items-center justify-center opacity-100"><span class="rounded-full bg-transparent w-3 h-3"></span></div>'
                    );
                },
            },
        });
    }

    // Text Slider
    const textSlider = document.querySelectorAll('[data-element="textslider"]');
    if (textSlider.length > 0) {
        textSlider.forEach((slider) => {
            new Swiper(slider, {
                slidesPerView: 1,
                autoHeight: false,
                modules: [Navigation],
                loop: false,
                grabCursor: true,
                spaceBetween: 15,
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },

                navigation: {
                    nextEl: slider.parentElement.querySelector(
                        ".swiper__button-next.mod-textslider",
                    ),
                    prevEl: slider.parentElement.querySelector(
                        ".swiper__button-prev.mod-textslider",
                    ),
                },
            });
        });
    }

    const textSliderOneColumn = document.querySelectorAll(
        '[data-element="onecolumn-textslider"]',
    );
    if (textSliderOneColumn.length > 0) {
        textSliderOneColumn.forEach((slider) => {
            new Swiper(slider, {
                slidesPerView: 1,
                autoHeight: false,
                modules: [Navigation],
                loop: false,
                grabCursor: true,
                spaceBetween: 15,

                navigation: {
                    nextEl: slider.parentElement.querySelector(
                        ".swiper__button-next.mod-textslider",
                    ),
                    prevEl: slider.parentElement.querySelector(
                        ".swiper__button-prev.mod-textslider",
                    ),
                },
            });
        });
    }

    // Contact Slider
    const contactSlider = document.querySelectorAll(
        '[data-element="contact-tabs-swiper"]',
    );
    if (contactSlider.length > 0) {
        contactSlider.forEach((slider) => {
            const slideCount = slider.querySelectorAll('.swiper-slide').length;

            let breakpoints = {};

            if (slideCount < 4) {
                breakpoints = {
                    768: {
                        slidesPerView: Math.min(slideCount, 3),
                    },
                    1024: {
                        slidesPerView: slideCount,
                    },
                };
            } else {
                breakpoints = {
                    768: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                };
            }

            new Swiper(slider, {
                slidesPerView: 1,
                autoHeight: false,
                modules: [Navigation],
                loop: false,
                grabCursor: true,
                spaceBetween: 15,
                breakpoints: breakpoints,

                navigation: {
                    nextEl: slider.parentElement.querySelector(
                        ".swiper__button-next.mod-contact_tabs",
                    ),
                    prevEl: slider.parentElement.querySelector(
                        ".swiper__button-prev.mod-contact_tabs",
                    ),
                },
            });
        });
    }

    // Header Sticky
    const dataObserve = document.querySelector("[data-observe]");
    const fHeader = document.querySelector(".f-header");
    const headerTop = document.querySelector(".header-top");

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    headerTop.classList.remove("is-sticky");
                    fHeader.classList.remove("is-sticky");
                } else {
                    headerTop.classList.add("is-sticky");
                    fHeader.classList.add("is-sticky");
                }
            });
        },
        {
            root: null,
            rootMargin: "100px",
            threshold: 0.1,
        },
    );

    observer.observe(dataObserve);

    // move modals to body
    const divsToMove = document.querySelectorAll(".modal");
    const body = document.getElementsByTagName("body")[0];

    Array.from(divsToMove).forEach((div) => {
        div.setAttribute("data-is-moved", "true");
        body.appendChild(div);
    });

    // Logo Padding
    setLogoPadding();

    // Logo Padding on Resize
    window.addEventListener("resize", setLogoPadding);
})();

const resetCategoryView = () => {
    const contentSection = document.querySelector(
        '[data-element="categories-nav-content"]',
    );
    if (contentSection && !contentSection.classList.contains("hidden")) {
        contentSection
            .querySelectorAll('[data-element="categories-nav-content-item"]')
            .forEach((item) => {
                item.setAttribute("aria-expanded", "false");
            });
        contentSection.classList.add("hidden");
        contentSection.classList.remove("block");

        document
            .querySelectorAll('[data-element="categories-nav-item"]')
            .forEach((item) => {
                item.setAttribute("aria-selected", "false");
            });
        return true;
    }
    return false;
};

window.addEventListener("load", () => {
    // Categorie Nav
    const categorieNav = document.querySelector(
        '[data-element="categories-nav"]',
    );

    if (categorieNav) {
        new CategorieNav(categorieNav, {
            scrollMarginTop: window.innerWidth > 1280 ? 120 : 0,
        });
    }


    const grid = document.querySelector(".grid-items");
    if (grid) {
        Isotope.Item.prototype.setPosition = function (x, y) { };

        const iso = new Isotope(grid, {
            itemSelector: ".grid-item",
            transitionDuration: "0",
            layoutMode: "fitRows",
            resize: false,
            hiddenStyle: {
                opacity: 0,
            },
            visibleStyle: {
                opacity: 1,
            },
        });

        grid.classList.add("isotope-grid");

        const filterBtns = document.querySelectorAll(".filter-btn");
        let activeFilters = [];

        iso.arrange({ filter: "*" });

        filterBtns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                const filterValue = btn.getAttribute("data-filter");

                resetCategoryView();

                if (activeFilters.includes(filterValue)) {
                    const index = activeFilters.indexOf(filterValue);
                    activeFilters.splice(index, 1);
                    btn.setAttribute("aria-selected", "false");
                } else {
                    activeFilters.push(filterValue);
                    btn.setAttribute("aria-selected", "true");
                }

                const filterString =
                    activeFilters.length > 0
                        ? activeFilters.map((f) => "." + f).join(", ")
                        : "*";

                iso.arrange({ filter: filterString });
            });
        });
    }
});
